import { makeAutoObservable, runInAction } from "mobx";
import apiHandler from "../handlers/ApiHandler";

class DefaultConfigStore {
  defaultConfigsMap = new Map();
  loading = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  getDefaultConfig(deviceTypeId) {
    const key = String(deviceTypeId).trim();
    return this.defaultConfigsMap.get(key) || null;
  }

  async fetchAllDefaultConfigs() {
    this.loading = true;
    this.error = null;

    try {
      const res = await apiHandler.get("/api/default-alert-configs");

      runInAction(() => {
        if (Array.isArray(res)) {
          res.forEach((config) => {
            if (config.device_type_id !== undefined) {
              const key = String(config.device_type_id).trim();
              this.defaultConfigsMap.set(key, config);
            }
          });
        }
        this.loading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.error =
          err.response?.data?.message || "Failed to fetch default configs.";
        this.loading = false;
      });
    }
  }

  async fetchDefaultConfig(deviceTypeId) {
    const key = String(deviceTypeId).trim();
    console.log("Here is key: ", key);
    if (this.defaultConfigsMap.has(key)) return;

    console.log("🔍 Fetching alert config for:", key);

    this.loading = true;
    this.error = null;

    try {
      const res = await apiHandler.get(`/api/default-alert-configs/${key}`);
      console.log("Here is response: ", res);
      runInAction(() => {
        this.defaultConfigsMap.set(key, res);
        this.loading = false;

        console.log(
          "🧠 Stored in default config map:",
          this.defaultConfigsMap.get(key)
        );
        console.log(
          "🔍 Full default config map:",
          Object.fromEntries(this.defaultConfigsMap.entries())
        );
        console.log("🔑 Keys:", [...this.defaultConfigsMap.keys()]);
        console.log("🔍 Map has key?", this.defaultConfigsMap.has(key));
      });
    } catch (err) {
      runInAction(() => {
        if (err.response?.status === 404) {
          this.defaultConfigsMap.set(key, null);
        } else {
          this.error =
            err.response?.data?.message || "Failed to fetch alert config.";
        }
        this.loading = false;
      });
    }
    // console.log("🔍 Full config map:", Object.fromEntries(this.alertConfigsMap.entries()));
    // console.log("🔍 Map now has:", this.alertConfigsMap.has(key));
    // console.log("🧠 All keys:", [...this.alertConfigsMap.keys()]);
  }

  async createDefaultConfig({ device_type_id, alertsConfig }) {
    this.loading = true;
    this.error = null;
    try {
      const res = await apiHandler.post(`/api/default-alert-configs`, {
        device_type_id,
        alertsConfig,
      });
      runInAction(() => {
        this.defaultConfigsMap.set(device_type_id, res.data);
        this.loading = false;
      });
      return res.data;
    } catch (err) {
      runInAction(() => {
        this.error =
          err.response?.data?.message || "Failed to create alert config.";
        this.loading = false;
      });
    }
  }

  async updateDefaultConfig(device_type_id, updatedData) {
    this.loading = true;
    this.error = null;

    try {
      const res = await apiHandler.put(
        `/api/default-alert-configs/${device_type_id}`,
        updatedData
      );

      const key = String(device_type_id).trim();
      const oldValue = this.defaultConfigsMap.get(key);

      console.log("🧪 old === new?", oldValue === res);
      console.log("🧪 old:", oldValue);
      console.log("🧪 new:", res);

      runInAction(() => {
        this.defaultConfigsMap.set(key, res);
        this.loading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.error =
          err.response?.data?.message || "Failed to update alert config.";
        this.loading = false;
      });
    }
  }

  async deleteDefaultConfig(device_type_id) {
    this.loading = true;
    this.error = null;
    try {
      await apiHandler.delete(`/api/default-alert-configs/${device_type_id}`);
      runInAction(() => {
        this.defaultConfigsMap.delete(device_type_id);
        this.loading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.error =
          err.response?.data?.message || "Failed to delete alert config.";
        this.loading = false;
      });
    }
  }

  clear() {
    this.defaultConfigsMap.clear();
    this.loading = false;
    this.error = null;
  }
}

const defaultConfigStore = new DefaultConfigStore();
export default defaultConfigStore;
